export const rillAnalyticsLinks = {
  rillAnalytics: () => '/analytics'
};
